import store from "../../../../store";
import { MUTUAL_FUNDS_HOUESE_ERROR, MUTUAL_FUNDS_HOUESE_HIDE_ERROR, } from "../../MutualFunds/interface/iMutualFundsHouses";
import { EXPLORE_WATCHLIST_SCHEMES, EXPLORE_PRODUCT_DETAILS, EXPLORE_CASH_FLOW, UPDATE_SUB_CATEGORY_ID, UPDATE_WATCHLIST_REQUEST_PAYLOAD_ID, EXPLORE_PRODUCT_TABS, UPDATE_BOOKMARK, EXPLORE_USER_POPUP_STATUS_SAVE, EXPLORE_USER_POPUP_STATUS, UPDATE_ONBOARD_POPUP, EXPLORE_DRAFT_ORDERS, EXPLORE_DRAFT_COUNT, EXPLORE_PRODUCT_TYPE_FILTERS, EXPLORE_PRODUCT_COUPON_FILTERS, EXPLORE_PRODUCT_PRICERANGE_FILTERS, EXPLORE_PRODUCT_ISSUERNAME_FILTERS, EXPLORE_PRODUCT_MATURITYDATE_FILTERS, EXPLORE_PRODUCT_INTERESTFREQUENCY_FILTERS, EXPLORE_PRODUCT_RATING_FILTERS, EXPLORE_PRODUCT_LOCAL_COUPON_FILTERS, EXPLORE_PRODUCT_LOCAL_INTERESTFREQUENCY_FILTERS, EXPLORE_PRODUCT_LOCAL_ISSUERNAME_FILTERS, EXPLORE_PRODUCT_LOCAL_MATURITYDATE_FILTERS, EXPLORE_PRODUCT_LOCAL_PRICERANGE_FILTERS, EXPLORE_PRODUCT_LOCAL_RATING_FILTERS, EXPLORE_PRODUCT_LOCAL_TYPE_FILTERS, RESET_VALUE_FILTER, EXPLORE_PRODUCT_LOCAL_MIN_INVESTMENT, EXPLORE_PRODUCT_LOCAL_AVAILABLE_QUANTITY, EXPLORE_PRODUCT_AVAILABLE_QUANTITY, EXPLORE_PRODUCT_MIN_INVESTMENT, MULTI_UPDATE_BOOKMARK, EXPLORE_BOOKMARK_SCHEMES_BONDS, EXPLORE_BOOKMARK_SCHEMES_UNLISTED_SHARES, EXPLORE_BOOKMARK_SCHEMES_NCD, EXPLORE_BOOKMARK_SCHEMES_SP, EXPLORE_BOOKMARK_SCHEMES, UPDATE_NCD_REQUEST_PAYLOAD_ID, UPDATE_BONDS_REQUEST_PAYLOAD_ID, UPDATE_SP_REQUEST_PAYLOAD_ID, UPDATE_UNLISTED_REQUEST_PAYLOAD_ID, EXPLORE_DOWNLOAD_DATA, EXPLORE_PRODUCT_LOCAL_PRODUCT_TYPE, EXPLORE_PRODUCT_LOCAL_STATUS, EXPLORE_PRODUCT_LOCAL_CLIENT_NAME, EXPLORE_PRODUCT_LOCAL_INVESTMENT_VALUE, USER_UNAUTHORIZED, } from "../interface/iProductBouquet";
var ProductBouquetActions = /** @class */ (function () {
    function ProductBouquetActions() {
        this.dispatch = store.dispatch;
    }
    ProductBouquetActions.prototype.userUnauthorized = function (error) {
        this.dispatch({
            type: USER_UNAUTHORIZED,
            payload: { userUnauthorized: error },
        });
    };
    ProductBouquetActions.prototype.getDownloadData = function (downloadData) {
        this.dispatch({
            type: EXPLORE_DOWNLOAD_DATA,
            payload: { downloadData: downloadData },
        });
    };
    ProductBouquetActions.prototype.getBookMark = function (bookMarkList) {
        this.dispatch({
            type: EXPLORE_BOOKMARK_SCHEMES,
            payload: { bookMarkList: bookMarkList },
        });
    };
    ProductBouquetActions.prototype.getMinInvestmentFilters = function (productMinInvestmentFilters) {
        this.dispatch({
            type: EXPLORE_PRODUCT_MIN_INVESTMENT,
            payload: { productMinInvestmentFilters: productMinInvestmentFilters },
        });
    };
    ProductBouquetActions.prototype.getAvailableQuantityFilters = function (productAvailableQuantityFilters) {
        this.dispatch({
            type: EXPLORE_PRODUCT_AVAILABLE_QUANTITY,
            payload: { productAvailableQuantityFilters: productAvailableQuantityFilters },
        });
    };
    ProductBouquetActions.prototype.getLocalMinInvestmentFilters = function (productLocalMinInvestmentFilters) {
        this.dispatch({
            type: EXPLORE_PRODUCT_LOCAL_MIN_INVESTMENT,
            payload: { productLocalMinInvestmentFilters: productLocalMinInvestmentFilters },
        });
    };
    ProductBouquetActions.prototype.getLocalAvailableQuantityFilters = function (productLocalAvailableQuantityFilters) {
        this.dispatch({
            type: EXPLORE_PRODUCT_LOCAL_AVAILABLE_QUANTITY,
            payload: { productLocalAvailableQuantityFilters: productLocalAvailableQuantityFilters },
        });
    };
    ProductBouquetActions.prototype.getLocalProductRatingFilters = function (productLocalRatingFilters) {
        this.dispatch({
            type: EXPLORE_PRODUCT_LOCAL_RATING_FILTERS,
            payload: { productLocalRatingFilters: productLocalRatingFilters },
        });
    };
    ProductBouquetActions.prototype.getLocalProductInterestFrequencyFilters = function (productLocalInterestFrequencyFilters) {
        this.dispatch({
            type: EXPLORE_PRODUCT_LOCAL_INTERESTFREQUENCY_FILTERS,
            payload: { productLocalInterestFrequencyFilters: productLocalInterestFrequencyFilters },
        });
    };
    ProductBouquetActions.prototype.getLocalProductMaturityDateFilters = function (productLocalMaturityDateFilters) {
        this.dispatch({
            type: EXPLORE_PRODUCT_LOCAL_MATURITYDATE_FILTERS,
            payload: { productLocalMaturityDateFilters: productLocalMaturityDateFilters },
        });
    };
    ProductBouquetActions.prototype.getLocalProductIssuerNameFilters = function (productLocalIssuerNameFilters) {
        this.dispatch({
            type: EXPLORE_PRODUCT_LOCAL_ISSUERNAME_FILTERS,
            payload: { productLocalIssuerNameFilters: productLocalIssuerNameFilters },
        });
    };
    ProductBouquetActions.prototype.getLocalProductPriceRangeFilters = function (productLocalPriceRangeFilters) {
        this.dispatch({
            type: EXPLORE_PRODUCT_LOCAL_PRICERANGE_FILTERS,
            payload: { productLocalPriceRangeFilters: productLocalPriceRangeFilters },
        });
    };
    ProductBouquetActions.prototype.getLocalProductTypeFilters = function (productLocalTypeFilters) {
        this.dispatch({
            type: EXPLORE_PRODUCT_LOCAL_TYPE_FILTERS,
            payload: { productLocalTypeFilters: productLocalTypeFilters },
        });
    };
    ProductBouquetActions.prototype.getLocalProductTypesFilters = function (productLocalProductTypeFilters) {
        this.dispatch({
            type: EXPLORE_PRODUCT_LOCAL_PRODUCT_TYPE,
            payload: { productLocalProductTypeFilters: productLocalProductTypeFilters },
        });
    };
    ProductBouquetActions.prototype.getLocalStatusFilters = function (productLocalStatusFilters) {
        this.dispatch({
            type: EXPLORE_PRODUCT_LOCAL_STATUS,
            payload: { productLocalStatusFilters: productLocalStatusFilters },
        });
    };
    ProductBouquetActions.prototype.getLocalClientNameFilters = function (productLocalClientNameFilters) {
        this.dispatch({
            type: EXPLORE_PRODUCT_LOCAL_CLIENT_NAME,
            payload: { productLocalClientNameFilters: productLocalClientNameFilters },
        });
    };
    ProductBouquetActions.prototype.getLocalInvestmentValueFilters = function (productLocalInvestmentValueFilters) {
        this.dispatch({
            type: EXPLORE_PRODUCT_LOCAL_INVESTMENT_VALUE,
            payload: { productLocalInvestmentValueFilters: productLocalInvestmentValueFilters },
        });
    };
    ProductBouquetActions.prototype.resetFilterValue = function () {
        this.dispatch({
            type: RESET_VALUE_FILTER,
            reducerName: "transactionJourneyFilter",
        });
    };
    ProductBouquetActions.prototype.getLocalProductCouponFilters = function (productLocalCouponFilters) {
        this.dispatch({
            type: EXPLORE_PRODUCT_LOCAL_COUPON_FILTERS,
            payload: { productLocalCouponFilters: productLocalCouponFilters },
        });
    };
    ProductBouquetActions.prototype.getProductRatingFilters = function (productRatingFilters) {
        this.dispatch({
            type: EXPLORE_PRODUCT_RATING_FILTERS,
            payload: { productRatingFilters: productRatingFilters },
        });
    };
    ProductBouquetActions.prototype.getProductInterestFrequencyFilters = function (productInterestFrequencyFilters) {
        this.dispatch({
            type: EXPLORE_PRODUCT_INTERESTFREQUENCY_FILTERS,
            payload: { productInterestFrequencyFilters: productInterestFrequencyFilters },
        });
    };
    ProductBouquetActions.prototype.getProductMaturityDateFilters = function (productMaturityDateFilters) {
        this.dispatch({
            type: EXPLORE_PRODUCT_MATURITYDATE_FILTERS,
            payload: { productMaturityDateFilters: productMaturityDateFilters },
        });
    };
    ProductBouquetActions.prototype.getProductIssuerNameFilters = function (productIssuerNameFilters) {
        this.dispatch({
            type: EXPLORE_PRODUCT_ISSUERNAME_FILTERS,
            payload: { productIssuerNameFilters: productIssuerNameFilters },
        });
    };
    ProductBouquetActions.prototype.getProductPriceRangeFilters = function (productPriceRangeFilters) {
        this.dispatch({
            type: EXPLORE_PRODUCT_PRICERANGE_FILTERS,
            payload: { productPriceRangeFilters: productPriceRangeFilters },
        });
    };
    ProductBouquetActions.prototype.getProductTypeFilters = function (productTypeFilters) {
        this.dispatch({
            type: EXPLORE_PRODUCT_TYPE_FILTERS,
            payload: { productTypeFilters: productTypeFilters },
        });
    };
    ProductBouquetActions.prototype.getProductCouponFilters = function (productCouponFilters) {
        this.dispatch({
            type: EXPLORE_PRODUCT_COUPON_FILTERS,
            payload: { productCouponFilters: productCouponFilters },
        });
    };
    ProductBouquetActions.prototype.getDraftOrders = function (draftOrders) {
        this.dispatch({
            type: EXPLORE_DRAFT_ORDERS,
            payload: { draftOrders: draftOrders },
        });
    };
    ProductBouquetActions.prototype.getDraftOrderCount = function (draftOrderCount) {
        this.dispatch({
            type: EXPLORE_DRAFT_COUNT,
            payload: { draftOrderCount: draftOrderCount },
        });
    };
    ProductBouquetActions.prototype.userPopupStatus = function (userPopupStatus) {
        this.dispatch({
            type: EXPLORE_USER_POPUP_STATUS,
            payload: { userPopupStatus: userPopupStatus },
        });
    };
    ProductBouquetActions.prototype.userPopupStatusSave = function (userPopupStatusSave) {
        this.dispatch({
            type: EXPLORE_USER_POPUP_STATUS_SAVE,
            payload: { userPopupStatusSave: userPopupStatusSave },
        });
    };
    ProductBouquetActions.prototype.getBookMarkSp = function (bookMarkListSp) {
        this.dispatch({
            type: EXPLORE_BOOKMARK_SCHEMES_SP,
            payload: { bookMarkListSp: bookMarkListSp },
        });
    };
    ProductBouquetActions.prototype.getBookMarkNcd = function (bookMarkListNcd) {
        this.dispatch({
            type: EXPLORE_BOOKMARK_SCHEMES_NCD,
            payload: { bookMarkListNcd: bookMarkListNcd },
        });
    };
    ProductBouquetActions.prototype.getBookMarkBonds = function (bookMarkListBonds) {
        this.dispatch({
            type: EXPLORE_BOOKMARK_SCHEMES_BONDS,
            payload: { bookMarkListBonds: bookMarkListBonds },
        });
    };
    ProductBouquetActions.prototype.getBookMarkUnlistedShares = function (bookMarkListUnlistedShares) {
        this.dispatch({
            type: EXPLORE_BOOKMARK_SCHEMES_UNLISTED_SHARES,
            payload: { bookMarkListUnlistedShares: bookMarkListUnlistedShares },
        });
    };
    ProductBouquetActions.prototype.updateBookMark = function (bookMark) {
        this.dispatch({
            type: UPDATE_BOOKMARK,
            payload: { bookMark: bookMark },
        });
    };
    ProductBouquetActions.prototype.multiUpdateBookMark = function (bookMark) {
        this.dispatch({
            type: MULTI_UPDATE_BOOKMARK,
            payload: { bookMark: bookMark },
        });
    };
    ProductBouquetActions.prototype.getProductTabs = function (productTabs) {
        this.dispatch({
            type: EXPLORE_PRODUCT_TABS,
            payload: { productTabs: productTabs },
        });
    };
    ProductBouquetActions.prototype.updateWatchListRequestPayload = function (watchListRequestPayload) {
        this.dispatch({
            type: UPDATE_WATCHLIST_REQUEST_PAYLOAD_ID,
            payload: { watchListRequestPayload: watchListRequestPayload },
        });
    };
    ProductBouquetActions.prototype.updateBookMarkNcdRequestPayload = function (watchListNcdRequestPayload) {
        this.dispatch({
            type: UPDATE_NCD_REQUEST_PAYLOAD_ID,
            payload: { watchListNcdRequestPayload: watchListNcdRequestPayload },
        });
    };
    ProductBouquetActions.prototype.updateBookMarkBondsRequestPayload = function (watchListBondsRequestPayload) {
        this.dispatch({
            type: UPDATE_BONDS_REQUEST_PAYLOAD_ID,
            payload: { watchListBondsRequestPayload: watchListBondsRequestPayload },
        });
    };
    ProductBouquetActions.prototype.updateBookMarkSpRequestPayload = function (watchListSpRequestPayload) {
        this.dispatch({
            type: UPDATE_SP_REQUEST_PAYLOAD_ID,
            payload: { watchListSpRequestPayload: watchListSpRequestPayload },
        });
    };
    ProductBouquetActions.prototype.updateBookMarkUnlistedRequestPayload = function (watchListUnlistedRequestPayload) {
        this.dispatch({
            type: UPDATE_UNLISTED_REQUEST_PAYLOAD_ID,
            payload: { watchListUnlistedRequestPayload: watchListUnlistedRequestPayload },
        });
    };
    ProductBouquetActions.prototype.getWatchListSchemes = function (watchListSchemes) {
        this.dispatch({
            type: EXPLORE_WATCHLIST_SCHEMES,
            payload: { watchListSchemes: watchListSchemes },
        });
    };
    ProductBouquetActions.prototype.getProductDetails = function (productDetails) {
        this.dispatch({
            type: EXPLORE_PRODUCT_DETAILS,
            payload: { productDetails: productDetails },
        });
    };
    ProductBouquetActions.prototype.getCashFlow = function (cashFlow) {
        this.dispatch({
            type: EXPLORE_CASH_FLOW,
            payload: { cashFlow: cashFlow },
        });
    };
    ProductBouquetActions.prototype.updateSubCategoryId = function (req) {
        this.dispatch({
            type: UPDATE_SUB_CATEGORY_ID,
            payload: {
                subCategoryId: req,
            },
        });
    };
    ProductBouquetActions.prototype.setError = function (payload, errorType) {
        this.dispatch({
            type: MUTUAL_FUNDS_HOUESE_ERROR,
            payload: { errorData: payload },
        });
    };
    ProductBouquetActions.prototype.hideError = function (errorType) {
        this.dispatch({
            type: MUTUAL_FUNDS_HOUESE_HIDE_ERROR,
        });
    };
    ProductBouquetActions.prototype.updateOnBoardPopup = function (value) {
        this.dispatch({
            type: UPDATE_ONBOARD_POPUP,
            payload: {
                isOnBoardPopup: value,
            },
        });
    };
    return ProductBouquetActions;
}());
export default ProductBouquetActions;
